import {
  ApiMutualFundAsset,
  ApiSegregatedPortfolioAsset,
  GetByTenantAssetListApiArg
} from 'api/rtk-api'
import { noop } from 'lodash'
import { createContext, useContext } from 'react'

import { TENANT } from '../../../const'

type Asset = ApiMutualFundAsset | ApiSegregatedPortfolioAsset
export const DEFAULT_STATE: { asset: Asset; setAsset: (asset: Asset) => void } = {
  asset: undefined,
  setAsset: noop
}

export const DEFAULT_QUERY: GetByTenantAssetListApiArg = {
  pageNumber: 1,
  pageSize: 20,
  tenant: TENANT
}

export const OrdersFiltersContext = createContext(DEFAULT_STATE)
export const useOrdersFiltersContext = () => useContext(OrdersFiltersContext)
